module.exports = __webpack_public_path__ + "static/media/Icons -_ Savingsactive_savings_icon.2005004b.svg";